/**

jQuery(document).off('click', '.selling-plan-btn button').on('click', '.selling-plan-btn button', function(e) {
    e.preventDefault();
    e.stopPropagation(); // Prevents event bubbling

    console.log('Button Clicked ATC');

    let productId = '49668836098355'; 
    let formData = new FormData(); 

    formData.append("id", productId);
    formData.append("quantity", 1);

    // Find the selected selling plan ID
    let sellingPlanId = '7547420979';

    if (sellingPlanId) {
        formData.append("selling_plan", sellingPlanId);
        console.log("Selling Plan ID Added:", sellingPlanId);
    } else {
        console.warn("No Selling Plan Selected");
    }

    window.k(formData, this);
    window.P();
});

let productId = '49691880718643'; 
let formData = new FormData(); 

formData.append("id", productId);
formData.append("quantity", 1);

// Find the selected selling plan ID
let sellingPlanId = '7547552051';

if (sellingPlanId) {
    formData.append("selling_plan", sellingPlanId);
    console.log("Selling Plan ID Added:", sellingPlanId);
} else {
    console.warn("No Selling Plan Selected");
}

// Find the actual form element
let formElement = document.querySelector("form"); // Adjust selector if needed

if (formElement) {
    window.k(formData, formElement);
    window.P();
} else {
    console.error("Form element not found.");
}

*/
jQuery(document).ready(function ($) {
  edAnnouncementSlider();

  $(".variant-option-group input[type='radio']").on("click", function () {
    console.log("Variation Changed!");
    edProductUpdateVariantData();
  });
  edProductUpdateVariantData();

  $(".ed-onetime-checkout")
    .off("click")
    .on("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      edAddToCartOnetime();
    });

  $(".ed-subscribe-checkout button")
    .off("click")
    .on("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      edAddToCartSubscibe();
    });
});

/**
 * Manage the Flickity Slider for Announcement Bar in the Header
 **/

function edAnnouncementSlider() {
  if (window.flickityInitialized) {
    return;
  } else {
    let sliders = document.querySelectorAll("[lsg-slider]");

    if (!sliders.length) {
      console.warn("No Flickity slider found on this page.");
    }

    sliders.forEach((t) => {
      // Check if Flickity is already initialized
      if (t.classList.contains("flickity-enabled")) {
        // console.log("Flickity already initialized for:", t);
        return; // Skip initialization
      }

      let options = {
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: 5000,
      };

      new Flickity(t, options);
    });
  }
}

/**
 * Get the ID of currently active variant
 **/
function edProductGetActiveVariant() {
  var checkedOption = $(".variant-option-group input[type='radio']:checked");
  if (checkedOption.length) {
    var variantId = $("input[name='id']").val();
    // console.log("Variant ID:", variantId);
    return variantId;
  } else {
    return;
  }
}

/**
 * Update Product Variant Information on Adult/Senior Page
 **/
function edProductUpdateVariantData() {
  var variantId = edProductGetActiveVariant(); // Get selected variant ID
  var productData = JSON.parse($("#ed-variant-data").text()); // Array or Object
  var variantData = JSON.parse($("#ed-variant-meta-data").text()); // Object

  // Check if productData is an array (variable product) or an object (simple product)
  var isVariableProduct = Array.isArray(productData);

  if (isVariableProduct) {
    // Variable product logic
    var activeVariant = variantData[String(variantId)];
    var variant = productData.find((v) => v.id == variantId);

    // Set variant ID in hidden input
    $("#ed-product-checkoutInfo").attr("data-ed-productid", variantId);

    if (variant) {
      $("span[data-ed-onetime]").text("$" + (variant.price / 100).toFixed(2));

      // Get and set selling plan ID if available
      if (variant.selling_plan_allocations.length > 0) {
        var sellingPlanId = variant.selling_plan_allocations[0].selling_plan_id;
        $("span[data-ed-subscribe]").text(
          "$" + (variant.selling_plan_allocations[0].price / 100).toFixed(2)
        );
        $("#ed-product-checkoutInfo").attr(
          "data-ed-selling-plan",
          sellingPlanId
        );
      } else {
        $("span[data-ed-subscribe]").text("N/A");
        $("#ed-product-checkoutInfo").attr("data-ed-selling-plan", ""); // Clear if no plan
      }
    } else {
      console.log("Variant not found in productData!");
    }

    if (activeVariant) {
      $("span[data-ed-servings]").text(activeVariant.product_servings);
      $("span[data-ed-servings-price]").text(activeVariant.price_per_service);
      $("span[data-ed-savetext]").text(activeVariant.discount_save_text);
    } else {
      console.error("Variant not found in variantData:", variantId);
    }
  } else {
    // Simple product logic
    var oneTimePrice = productData.price / 100;
    $("span[data-ed-onetime]").text("$" + oneTimePrice.toFixed(2));

    // Set product ID in hidden input
    $("#ed-product-checkoutInfo").attr("data-ed-productid", productData.id);

    var subscriptionPrice = null;
    var sellingPlanId = null;

    if (productData.selling_plan_allocations?.length > 0) {
      subscriptionPrice = productData.selling_plan_allocations[0].price / 100;
      sellingPlanId = productData.selling_plan_allocations[0].selling_plan_id;

      $("span[data-ed-subscribe]").text("$" + subscriptionPrice.toFixed(2));
      $("#ed-product-checkoutInfo").attr("data-ed-selling-plan", sellingPlanId);

      // console.log("Subscription Price: $" + subscriptionPrice.toFixed(2));
      // console.log("Selling Plan ID:", sellingPlanId);
    } else {
      $("span[data-ed-subscribe]").text("N/A");
      $("#ed-product-checkoutInfo").attr("data-ed-selling-plan", ""); // Clear if no plan
      console.log("No Subscription Price Available");
    }

    // Calculate percentage difference if subscription price exists
    if (subscriptionPrice !== null && oneTimePrice > 0) {
      var discountPercentage =
        ((oneTimePrice - subscriptionPrice) / oneTimePrice) * 100;
      discountPercentage = discountPercentage; // Keep two decimal places

      $("span[data-ed-savetext]").text("Save " + discountPercentage + "%");
    }

    // Update metadata for a simple product if applicable
    if (variantData[String(productData.id)]) {
      var activeProduct = variantData[String(productData.id)];
      $("span[data-ed-servings]").text(activeProduct.product_servings);
      $("span[data-ed-servings-price]").text(activeProduct.price_per_service);
    }
  }
}

/**
 * Add to Cart function for One-time Purchase
 **/
function edAddToCartOnetime() {
  // Use .attr() instead of .data() to ensure updated value is fetched
  let productId = $("#ed-product-checkoutInfo").attr("data-ed-productid");
  let qty = $('input[name="product-quantity"]').val();

  let formData = new FormData();

  formData.append("id", productId);
  formData.append("quantity", qty);

  // Find the actual form element
  let formElement = document.querySelector("form"); // Adjust selector if needed

  if (formElement) {
    window.k(formData, formElement);
    window.P();
  } else {
    console.error("Form element not found.");
  }
}

/**
 * Add to Cart function for Subscriptions
 **/
function edAddToCartSubscibe() {
  // Use .attr() instead of .data() to ensure updated value is fetched
  let productId = $("#ed-product-checkoutInfo").attr("data-ed-productid");
  let sellingPlanId = $("#ed-product-checkoutInfo").attr(
    "data-ed-selling-plan"
  );

  let formData = new FormData();

  formData.append("id", productId);
  formData.append("quantity", 1);

  if (sellingPlanId) {
    formData.append("selling_plan", sellingPlanId);
    // console.log("Selling Plan ID Added:", sellingPlanId);
  } else {
    console.warn("No Selling Plan Selected");
  }

  // Find the actual form element
  let formElement = document.querySelector("form"); // Adjust selector if needed

  if (formElement) {
    window.k(formData, formElement);
    window.P();
  } else {
    console.error("Form element not found.");
  }
}
